import styled from 'styled-components';
import { ButtonWrapper } from '../Button';

export const Content = styled.div`
  width: 130px;
  text-align: left;
  padding: ${({ theme }) => theme.spacing4}px;
  ul {
    margin: 0 0 ${({ theme }) => theme.spacing4}px;
    padding: 0;
    list-style: none;
  }
  li {
    margin: 3px 0;
  }
  label {
    text-transform: none;
  }
  input[type='number'] {
    width: 101px;
    text-align: left;
    margin: 0;
  }
`;

export const Buttons = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing8}px;
  align-items: center;
  margin-top: ${({ theme }) => theme.spacing8}px;
  width: 100%;
  ${ButtonWrapper} {
    flex: 1;
  }
`;

export const SlippageWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  input {
    width: 40px;
    margin-left: ${({ theme }) => theme.spacing4}px;
  }
`;
